import sendLocalRequest from "../sendLocalRequest";

export const callSearchUsers = (auth_token, search_string) => {
    return  new Promise( (resolve, reject) => {
        if (search_string === undefined) {
            reject(new Error("search_string is required"));
        }

        const body = {
            "search_string": search_string
        }

        let url = "users/search_users";

        sendLocalRequest(url, "POST", auth_token, body).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
